export default (url) => {
  window.messageBus = window.messageBus || [];
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  document.head.appendChild(script);
};

export const sendEvent = (name, payload) => {
  // Window messageBus will be defined by ecosia analytics
  // If analytics is not loaded due to do not track setting
  // we want to ensure this method is not throwing an error.
  window.messageBus = window.messageBus || [];
  window.messageBus.push({ name, payload });
};

export const sendCoreAnalyticsEvent = (name, payload = {}) => {
  const eventName = 'core-analytics-event';

  const event = new CustomEvent(eventName, {
    bubbles: true,
    cancelable: false,
    composed: true,
    detail: {
      name,
      payload,
    },
  });

  window.dispatchEvent(event);
};
